<template>
  <div class="wl-banner-list rounded-2xl" :class="`type-${type}`">
    <WLBaseExpandable :initial-state="{ isOpen }">
      <template #summary="{ isOpen, toggle }">
        <div
          ref="toggleRef"
          class="flex items-center gap-2 p-3"
          @click="toggle"
        >
          <WLIcon
            v-if="iconName"
            :name="iconName"
            :size="IconSize.SMALL"
            class="flex-shrink-0"
          />
          <div class="grow">
            <p class="line-clamp-1 text-sm font-medium">
              {{ title }}
            </p>
            <p class="font-regular text-sm">
              {{ message }}
            </p>
          </div>
          <div class="flex items-center gap-2">
            <WLTag v-if="subItemsCount && subItemsCount > 0" :type="tagType">
              {{ subItemsCount }}
            </WLTag>
            <WLIcon
              :name="IconName.CONTROLS_CHEVRON_DOWN"
              :size="IconSize.SMALL"
              class="transition-transform duration-300"
              :class="{ 'rotate-180': isOpen }"
            />
          </div>
        </div>
      </template>
      <template #details>
        <div
          v-if="$slots.default"
          class="wl-banner-list-border border-t border-solid"
        >
          <div class="flex flex-col gap-3 p-3">
            <slot />
          </div>
        </div>
      </template>
    </WLBaseExpandable>
  </div>
</template>

<script setup lang="ts">
import { IconName, IconSize, WLIcon } from "../icon";
import { WLTag } from "../tag";
import { WLBaseExpandable } from "../base-expandable";
import type { BannerListProps } from "./types";
import { computed } from "vue";

const {
  type = "warning",
  iconName,
  title,
  message,
  isOpen,
  subItemsCount,
} = defineProps<BannerListProps>();

const tagType = computed(() => {
  switch (type) {
    case "warning":
      return "warning";
    default:
      return "primary";
  }
});
</script>

<style>
@reference "@theme";

.wl-banner-list {
  &.type-default {
    @apply text-emphasis;

    .wl-banner-list-border {
      @apply border-theme-transparent;
    }
  }

  &.type-warning {
    @apply bg-warning-transparent text-warning;

    .wl-banner-list-border {
      @apply border-warning-transparent;
    }
  }
}
</style>
